import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, pw);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 font-heading font-bold text-brand-blue text-xl mb-8">
          <span className="inline-flex w-8 h-8 rounded-xl bg-brand-blue text-white items-center justify-center">
            <Sparkles size={16} />
          </span>
          FuturePath
        </Link>
        <h1 className="text-3xl font-semibold text-brand-blue">Welcome back</h1>
        <p className="mt-2 text-brand-muted">Log in to see your reports, chats and dashboard.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="block text-sm font-medium text-brand-blue mb-1.5">Email</label>
            <input data-testid="login-email-input" type="email" required className="field" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-medium text-brand-blue mb-1.5">Password</label>
            <input data-testid="login-password-input" type="password" required minLength={6} className="field" value={pw} onChange={(e) => setPw(e.target.value)} />
          </div>
          <button data-testid="login-submit-btn" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? "Logging in..." : "Log in"}
          </button>
        </form>
        <p className="mt-6 text-sm text-center text-brand-muted">
          New here? <Link to="/signup" data-testid="login-signup-link" className="text-brand-green font-medium">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
